import { red } from '@mui/material/colors';
import React, { useContext } from 'react';
import { get_cod } from '../../../utils/cod';
import {
  displayLocation,
  extractMapsPlaceLink,
} from '../../../utils/locations';
import { displayMoney } from '../../../utils/money';
import CopyLinkButton from '../../common/copy-link-button/copy-link-button';

import { GenericList } from '../../common/generic-list/generic-list';
import {
  IconWithText,
  mobileDoubleItemsGrid,
} from '../../common/styles/components';
import {
  getDeliveryBatchStateColor,
  getDeliveryBatchStateIcon,
  showDeliveryBatchChip,
  showDeliveryBatchState,
} from '../../common/styles/delivery-batch.styles';
import { showDeliveryState } from '../../common/styles/order-states.style';
import {
  getPickupTaskStateColor,
  getPickupTaskStateIcon,
  showPickupTaskChip,
  showPickupTaskState,
} from '../../common/styles/pickup-task.styles';
import { showWorkflow } from '../../common/styles/workflow-display';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Updater } from 'use-immer';
import { SortingByColumnState } from '../../common/generic-table/utils';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import InventoryIcon from '@mui/icons-material/Inventory';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ChecklistIcon from '@mui/icons-material/Checklist';
import LinkIcon from '@mui/icons-material/Link';
import { IDeliveryBatch } from '../../../interfaces/delivery-company/tasks';
import { format } from 'date-fns';
import { Box, IconButton } from '@mui/material';
import { Workflow } from '../../../enums/orders';
import { canCompletePickupTask } from '../../../utils/pickup-tasks';
import { AuthContext } from '../../../contexts/user-context/user-context';
import HouseIcon from '@mui/icons-material/House';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import DownloadIcon from '@mui/icons-material/Download';
import { ClearIcon } from '@mui/x-date-pickers';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import CancelIcon from '@mui/icons-material/Cancel';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import { DriverWithIcon } from '../../common/styles/driver-with-icon';
import { DoneOutline, FactCheckOutlined, Print } from '@mui/icons-material';
import { DeliveryBatchState } from '../../../enums/tasks';
import { isFrozen } from '../../../utils/delivery-tasks';
import { DataResources, ResourceActionType, user_has_data_model_access } from '../../../utils/permissions';
import ActionMenu from '../../common/action-menu';

export const delivery_batches_relevant_fields = [
  'id',
  'status',
  'package_count',
  'creation_date',
  'created_by',
  'branch',
  'driver',
];

interface ResponsiveDeliveryBatchesListingProps {
  tasksList: IDeliveryBatch[];
  isLoading: boolean;
  setEditingTask: React.Dispatch<
    React.SetStateAction<IDeliveryBatch | undefined>
  >;
  setDownloadBatchQrcode: React.Dispatch<
    React.SetStateAction<IDeliveryBatch | undefined>
  >;
  setCancellingTask: React.Dispatch<
    React.SetStateAction<IDeliveryBatch | undefined>
  >;
  setCompletingTask: React.Dispatch<
    React.SetStateAction<IDeliveryBatch | undefined>
  >;
  setDownloadWaybillForTask: React.Dispatch<
    React.SetStateAction<IDeliveryBatch | undefined>
  >;
  setDownloadReturnStatementsForTask: React.Dispatch<
    React.SetStateAction<IDeliveryBatch | undefined>
  >;
}

const ResponsiveDeliveryBatchesListing = ({
  tasksList,
  isLoading,
  setEditingTask,
  setDownloadBatchQrcode,
  setCancellingTask,
  setCompletingTask,
  setDownloadWaybillForTask,
  setDownloadReturnStatementsForTask,
}: ResponsiveDeliveryBatchesListingProps) => {
  const { user, config } = useContext(AuthContext);

  return (
    <GenericList<IDeliveryBatch>
      sourceView="delivery-tasks-listing"
      items={tasksList}
      selectedItems={new Map()}
      updateSelectedItems={() => {
        throw new Error('unimplemented');
      }}
      isLoading={isLoading}
      fullWidth
      columns={[
        {
          id: 'task_id',
          header: <p>Task ID</p>,
          display_body: (task) => {
            if (task.status != DeliveryBatchState.ASSIGNED) return task.id;
            return (
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => setEditingTask(task)}
              >
                {' '}
                <b>
                  <u>{task.id}</u>
                </b>
              </div>
            );
          },
        },
        {
          id: 'creation_date',
          header: <p>Created At</p>,
          display_body: (task) => (
            <p>
              {format(new Date(task.creation_date ?? ''), 'dd-MM-yyyy HH:mm')}
            </p>
          ),
        },
        {
          id: 'branch',
          header: <p>Branch</p>,
          display_body: (task) => <>{task.branch?.name}</>
        },
        {
          id: 'driver',
          header: <p>Driver</p>,
          display_body: (task) => <DriverWithIcon driver={task.driver} centered />
        },
        {
          id: 'task_state',
          header: <p>Status</p>,
          display_body: (task) => (
            <>
              {showDeliveryBatchState(task.status)} <br />
              
            </>
          ),
        },
        {
          id: 'orders_count',
          header: <p># Packages</p>,
          display_body: (task) => <p>{task.package_count}</p>,
        },
        {
          id: 'print',
          header: <p>Print</p>,
          display_body: (task) => {
            const actions = [
              {
                icon: <DownloadIcon />,
                label: 'Batch QR Code',
                onClick: () => setDownloadBatchQrcode(task),
              },
              {
                icon: <DownloadIcon />,
                label: 'Waybills',
                onClick: () => setDownloadWaybillForTask(task),
                disabled: task.package_count == 0
              },
              {
                icon: <DownloadIcon />,
                label: 'Return Statements',
                onClick: () => setDownloadReturnStatementsForTask(task),
                disabled: task.package_count == 0
              },
            ];
        
        
            return <ActionMenu icon={<Print fontSize='medium' />} actions={actions}/>;
          },
        },
        {
          id: 'complete_collection',
          header: <p>Complete</p>,
          display_body: (task) => {
            return (
              <IconButton
                disabled={task.status != DeliveryBatchState.ASSIGNED || !user_has_data_model_access(user, DataResources.DELIVERY_BATCH, ResourceActionType.UPDATE)}
                onClick={() => setCompletingTask(task)}
              >
                <DoneOutline color={(task.status == DeliveryBatchState.ASSIGNED && user_has_data_model_access(user, DataResources.DELIVERY_BATCH, ResourceActionType.UPDATE)) ? "primary" : "secondary"} />
              </IconButton>
            );
          },
        },
        {
          id: 'cancel_task',
          header: <p>Cancel</p>,
          display_body: (task) => {
            return (
              <IconButton
                disabled={task.status != DeliveryBatchState.ASSIGNED || !user_has_data_model_access(user, DataResources.DELIVERY_BATCH, ResourceActionType.DELETE)}
                onClick={() => setCancellingTask(task)}
              >
                <CancelIcon />
              </IconButton>
            );
          },
        },
      ]}
      getItemUID={(order) => order.id}
      rowConfigs={[
        {
          display_row: (task) => <b>Delivery Batch #{task.id}</b>,
        },
        {
          display_row: (task) => (
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: '#f0f0f0', // Light gray background
                borderRadius: '12px', // Rounded corners
                padding: '4px 8px', // Padding around the text
              }}
            >
              {task.package_count} items
            </Box>
          ),
        },
        {
          display_row: (task) => (
            <>
              {task.creation_date &&
                new Date(task.creation_date).toLocaleDateString()}
            </>
          ),
        },
        {
          display_row: (task) => (
            <DriverWithIcon centered key={'driver'} driver={task.driver} />
          ),
        },
        {
          display_row: (task) => {
            return mobileDoubleItemsGrid([
              <div
                key={'receive packages'}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignContent: 'center',
                }}
              >
                Master QR Code <br />
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setDownloadBatchQrcode(task);
                  }}
                >
                  <DownloadIcon fontSize="large" color="primary" />
                </IconButton>
              </div>,
              <div
                key={'download waybills'}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignContent: 'center',
                }}
              >
                Waybills <br />
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setDownloadWaybillForTask(task);
                  }}
                >
                  <DownloadIcon fontSize="large" color="primary" />
                </IconButton>
              </div>,
            ]);
          },
        },
        {
          display_row: (task) => {
            return (
              <div style={{ width: '100%', textAlign: 'center' }}>
                {!isFrozen(task) && (
                  <div
                    key={'cancel task'}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignContent: 'center',
                    }}
                  >
                    Cancel Task <br />
                    <IconButton
                      disabled={isFrozen(task)}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCancellingTask(task);
                      }}
                    >
                      <CancelIcon fontSize="large" />
                    </IconButton>
                  </div>
                )}
              </div>
            );
          },
        },
      ]}
      cardFooter={(task) => {
        return {
          content: (
            <IconWithText centered>
              {getDeliveryBatchStateIcon(task.status)}
              <>{task.status.replaceAll('_', ' ')}</>
            </IconWithText>
          ),
          background: getDeliveryBatchStateColor(task.status),
        };
      }}
      cardIcon={(task) => <LocalShippingIcon color={'primary'} />}
      onCardClick={(task) => setEditingTask(task)}
    />
  );
};

export default ResponsiveDeliveryBatchesListing;
